__turbopack_context__.v({
  "SFooterHeading": "IFoapW_SFooterHeading",
});
